import { createFetchClient } from "@shared/apis/fetch-clients/fetch-client-factory";
import { appConfig } from "@shared/utils/appConfig";
import { getApiRootUrl } from "@shared/utils/api-root-url";

export type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@shared/apis/fetch-clients/fetch-client-factory";

// CRM_API_URL only differs from the brand-aware root when running backends
// locally without the Vite proxy (see .env.example's "Scenario 1") - staging
// and production must stay brand-aware via getApiRootUrl().
const baseUrl =
  appConfig.APP_ENV === "development" ? appConfig.CRM_API_URL : getApiRootUrl();

const client = createFetchClient(`${baseUrl}/crm`);
export { client };
export default client;
